import React, { Component } from 'react';
import { collection, getFirestore, onSnapshot } from "firebase/firestore";
import { app } from '../util/firebase';

class ListPrets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prets : []
        };  
    }


    componentDidMount(){
        onSnapshot(collection(getFirestore(app),"prets"), (snapshot)=>{
            snapshot.forEach((snap)=>{
                let pret = snap.data();
                this.setState({prets: [...this.state.prets,pret]})
            })
        })
    }
    


    render(){
        return (
            <div>
                    <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>User Name</th>
                            <th>email</th>
                            <th>Date Pret</th>                         
                            <th>A rembourser avant</th>
                            <th>Montant</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.prets.map((pret,i)=>{
                            let year = pret.dateDebut.toDate().getFullYear()
                            let month = pret.dateDebut.toDate().getMonth()+1
                            let day = pret.dateDebut.toDate().getDate()
                            return(
                                <tr key={i}>
                                    <td>{pret.userName}</td>
                                    <td>{pret.email}</td>
                                    <td>{(year)+"-" + (month>9? (month):("0"+month))+"-" + (day>9? (day):("0"+day))}</td>
                                    <td>{pret.dateFin}</td>
                                    <td>{pret.montant}</td>
                                </tr>
                            )})
                    }
                    </tbody>
                </table>
            </div>
    );
    }
};
export default ListPrets;